import { render, staticRenderFns } from "./CompareSectNew.vue?vue&type=template&id=a9024ed0&"
import script from "./CompareSectNew.vue?vue&type=script&lang=js&"
export * from "./CompareSectNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a9024ed0', component.options)
    } else {
      api.reload('a9024ed0', component.options)
    }
    module.hot.accept("./CompareSectNew.vue?vue&type=template&id=a9024ed0&", function () {
      api.rerender('a9024ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/CompareSectNew.vue"
export default component.exports